import React, { useEffect, useState } from "react";
import { Avatar, Button, Card, Col, Descriptions, Row, Space } from "antd";
import { ReactComponent as CalenderSvg } from "../../../assets/images/description/calendar.svg";
import { ReactComponent as CrownSvg } from "../../../assets/images/description/Crown.svg";
import { mySubscription } from "../../../redux/action/mySubscription/mySubscription";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

// Breakpoints
const descriptions_breakpoint = {
  xxl: 4,
  xl: 4,
  lg: 4,
  md: 4,
  sm: 2,
  xs: 1,
};

const ManageSubscription = () => {
  const dispatch = useDispatch();
  const [subsData, setSubsData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await dispatch(mySubscription());
      setSubsData(response);
    };

    fetchData();
  }, [dispatch]);
  const today = dayjs();

  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <CrownSvg /> Subscription Plan
        </>
      ),
      children: subsData?.subscription_name_en ?? "N/A",
    },
    {
      key: "2",
      label: (
        <>
          <CalenderSvg /> Subscription Start Date
        </>
      ),
      children:
        dayjs(subsData?.subscription_start_date).format("MM-DD-YYYY") ?? "-",
    },
    {
      key: "3",
      label: (
        <>
          <CalenderSvg /> Subscription End Date
        </>
      ),
      children:
        dayjs(subsData?.subscription_end_date).format("MM-DD-YYYY") ?? "-",
    },
    {
      key: "4",
      label: (
        <>
          <CalenderSvg /> Number of Days Left
        </>
      ),
      children: subsData?.subscription_end_date
        ? (() => {
            const daysLeft = dayjs(subsData.subscription_end_date)
              .startOf("day")
              .diff(today.startOf("day"), "day");

            return daysLeft <= 0
              ? "Expired"
              : `${daysLeft} day${daysLeft === 1 ? "" : "s"}`;
          })()
        : "N/A",
    },
  ];
  return (
    <>
      <div className="viewTenant">
        <div className="tableHeading">Subscription Plan Details</div>
      </div>
      <Card>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24}>
            <div className="customDescription">
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={basicInfo_details}
                size="small"
                column={descriptions_breakpoint}
              />
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ManageSubscription;
